export const RAPPICARD_BR_TERMS = {
  Header: 'TERMOS E CONDIÇÕES DA CAMPANHA 5% DE DESCONTO NO RAPPI TRAVEL PARA USUÁRIOS PRIME',
  Body: [
    {
      Title: null,
      Paragraphs: [
        `Por meio deste documento, divulgamos os Termos e Condições da campanha
        denominada "<strong>5% DE DESCONTO NO RAPPI TRAVEL PARA USUÁRIOS PRIME</strong>
        ”(doravante“ Campanha”), por meio da qual os usuários / consumidores com a
        categoria PRIME que realizam uma compra na seção chamada "Rappi TRAVEL"
        dentro da Plataforma Rappi, no período de tempo compreendido entre os dias
        <strong>15 de agosto a 30 de setembro de 2021</strong>, receberão cinco por
        cento (5%) de desconto no valor total do pedido, para compras realizadas
        apenas nas seções de Hotel e Aluguel de Carros.`,
      ]
    },
    {
      Title: 'Termos:',
      Paragraphs: [
        `1. Campanha válida apenas durante o período de tempo entre
        <strong>12:01 de 15 de agosto de 2021 e 11h59PM de 30 de setembro de 2021</strong>, 
        e / ou enquanto durar o estoque, o que significa acontecer primeiro. O
        desconto só será concedido ao usuário / consumidor que fizer compras nas
        seções Hotéis e aluguel de veículos.
        <strong>Não se aplica para compra de passagens aéreas</strong>.`,
        '2. Campanha válida apenas para usuários da categoria Rappi PRIME.',
        `3. Campanha válida apenas para os primeiros
        <strong>mil (1000) </strong>pedidos que são realizadas durante a vigência
        desta Campanha, que cumprem com as condições estabelecidas nestes termos e
        condições.`,
        '4. Pedidos ilimitados por usuário / consumidor.',
        `5. Esclarece-se que esta Campanha é válida apenas para usuários /
        consumidores, que realizam suas compras na Plataforma Rappi na seção chamada
        "<strong>Viagem Travel</strong>" no Brasil durante a validade indicada no
        número 1 destes termos e condições.`,
        ` 6. Esclarece-se que esta Campanha se aplica apenas a pedidos pago com cartão
        de crédito (qualquer aceito dentro do Rappi). Qualquer pagamento feito pelo
        Usuário / Consumidor com outra forma de pagamento que não seja cartão de
        crédito não será levado em consideração para calcular a porcentagem de
        desconto.`,
        `7. O benefício obtido em virtude desta Campanha não é Combinável ou seja,
        acumulatica, com outras promoções exibidas na Plataforma Rappi.`,
        `8. É esclarecido que estes termos e condições são sujeito aos Termos e
        Condições de Uso da Plataforma Rappi, o que estão no seguinte link:
        <a href="https://legal.rappi.com/brazil/termos-e-condicoes-app-soy-shopper/">
            <span>
            https://legal.rappi.com/brazil/termos-e-condicoes-app-soy-shopper/
            </span>
        </a>`,
        `9. O usuário / consumidor reconhece e aceita que as informações fornecido e
        registrado na Plataforma Rappi, é verdadeiro e confiável, assumindo total
        responsabilidade por sua falsidade.`,
        ` 10. Rappi reserva-se o direito de cancelar pedidos se detectar intenção de
        fraude.`,
        `11. Rappi reserva-se o direito de rejeitar e cancelar qualquer pedido que,
        pelas suas características, o Rappi determina que não se aplica ao benefício
        concedido no âmbito desta Campanha, sem prévio aviso ao usuário /
        consumidor.`,
        '12. Rappi não vende produtos, pois é apenas uma plataforma contato.',
        ` 13. RAPPI reserva-se o direito, a seu exclusivo critério, de modificar,
        alterar ou, de outra forma, atualizar estes Termos e Condições em qualquer
        momento. As modificações serão comunicadas no aplicativo RAPPI e eles
        entrarão em vigor imediatamente a partir do momento de sua publicação.`,
        `14. Rappi não permitirá que o usuário / consumidor acesse o benefício quando
        se verifica que as contas são fictícias ou de falsos Usuários que realmente
        não constituem uma pessoa humana identificável por meio de um documento de
        identidade emitido por uma autoridade competente.`,
      ]
    }
  ]
};
